/* tslint:disable:no-inferrable-types no-trailing-whitespace import-spacing typedef-whitespace align */

import { WindowType       } from './window';
import { DocumentMetadata } from './document.metadata';
import {Scenario} from "@/models/scenario/scenario";

/**
 *
 * @class ConnectionViewerMetadata
 *
 * @brief meta data for connection viewer (routes through a decision point)
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      January 2024
 *
 */
export class ConnectionViewerMetadata extends DocumentMetadata {

  public key:  string            = '/';

  public scenario: Scenario|null = null;

  public dp: string              = '';

  /** standard constructor */
  constructor(
    id:       string = '',
    title:    string = '',
    key:      string|Scenario = '',
    dp:       string = '',
    icon:     string = '<i class="fas fa-project-diagram"></i>',
    type: WindowType = WindowType.ConnectionViewer,
  ) {

    super(id, title, icon, type);

    if (key instanceof Scenario) {

      this.scenario = key;

    } else {

      this.key = key;
    }

    this.dp   = dp;
  }

  /** convert this element to a simplified form that can be easily serialized */
  public node(init?: any) {

    return super.node({key: this.key});
  }

  /** initialize this element given the data in the simplified node object */
  public fromNode(node: any) {

    super.fromNode(node);

    this.key  = node.key;
  }
}
